export default __webpack_public_path__ + "static/media/publish.9537493e.svg";